module.exports = __webpack_public_path__ + "static/media/bocongthuong.bb92516e.png";